<template>
  <v-app>
    <toolbar class="app--toolbar"></toolbar>
    <drawer class="app--drawer"></drawer>

    <v-main>
      <v-container class="page-wrapper" fluid>
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-container>
      <v-footer height="auto" class="white pa-3 app--footer">
        <span class="caption">
          {{ new Date().getFullYear() }} &copy; DGESU, Todos los derechos
          reservados
        </span>
        <v-spacer></v-spacer>
        <span class="caption mr-1">
          <a href="//dgesu.minedu.gob.bo/" target="_blank" style="text-decoration: none">Dirección General de Educación
            Superior Universitaria</a>
        </span>
      </v-footer>
    </v-main>
    <Snackbar />
  </v-app>
</template>

<script>
import Toolbar from "@/components/Toolbar";
import Drawer from "@/components/Drawer";
import Snackbar from "@/components/Snackbar";
export default {
  name: "App",
  components: {
    Toolbar,
    Drawer,
    Snackbar,
  },
  data() {
    return {
      //
    };
  },
  created() {
    window.getApp = this;
  },
};
</script>
<style lang="css" scoped>
.page-wrapper {
  min-height: calc(100vh - 64px - 50px);
  background-color: #fbfbfb;
  background-image: url("assets/minedu-background.jpg");
  background-attachment: fixed;
  background-size: cover;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.logo {
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 16px !important;
}

.v-application--is-rtl .v-list-item__action:first-child,
.v-application--is-rtl .v-list-item__icon:first-child {
  margin-left: 16px !important;
}

.v-application--is-rtl .v-list-item__action:last-of-type:not(:only-child),
.v-application--is-rtl .v-list-item__icon:last-of-type:not(:only-child) {
  margin-right: 16px !important;
}
</style>
